module.exports = __webpack_public_path__ + "static/media/pdf.1230baae.svg";